import React from 'react';
import PropTypes from 'prop-types'
import { Alert } from '@paypalcorp/pp-react';

const className = 'sign_up_alert'

class SignUpAlert extends React.Component {
  render() {
    if (this.props.signUpStatus) {
      return <Alert type="success" className={className}>
        {this.props.successMessage}
      </Alert>
    }
    
    return <Alert type="info" className={className}>
      {this.props.failMessage}
    </Alert>;
  }
}

SignUpAlert.propTypes = {
  signUpStatus: PropTypes.bool,
  successMessage: PropTypes.string,
  failMessage: PropTypes.string,
}

export default SignUpAlert;
